/** Safe categories: error messages never include config values, response bodies or URLs. */
export type EnvErrorCode =
  | 'not-ready'
  | 'source-conflict'
  | 'validation'
  | 'http'
  | 'network'
  | 'json'
  | 'timeout'
  | 'aborted'
  | 'invalid-options'
  | 'missing-key';

export class EnvError extends Error {
  constructor(public readonly code: EnvErrorCode, message: string) {
    super(`[@abax/platform/env] ${message}`);
    this.name = 'EnvError';
  }
}
